// src/components/pages/backtest/partials/ActionButtonsSection.js

import React from 'react';
import { toast } from 'react-toastify';
import styles from '../style/BacktestPage.module.css';

const ActionButtonsSection = ({ setup, runner, t }) => {
    return (
        <>
            {/* 5. 메시지 및 실행 버튼 */}
            {setup.message && <div className={`${styles.messageBox} ${runner.getMessageClass(setup.message)}`}>{setup.message}</div>}

            <button onClick={runner.handleRunBacktest} className={styles.runButton} disabled={setup.isLoadingBenchmark}>
                {t("backtest.runBacktest")}
            </button>

            {/* 공유 링크 버튼 (상단) */}
            {setup.isBacktestReady && setup.rows.length > 0 && (
                <button
                    onClick={() => { navigator.clipboard.writeText(window.location.href); toast.info(t("linkCopied")); }}
                    className={styles.runButton} 
                    style={{ marginTop: '10px', marginBottom: '10px', backgroundColor: '#5cb85c' }} 
                >
                    {t("shareLink")}
                </button>
            )}

 
        </>
    );
};

export default ActionButtonsSection;